"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TimePicker = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var R = __importStar(require("../../utils/ramda"));
var ListView_1 = require("../../components/ListView");
var Stack_1 = require("../../components/Stack");
var Box_1 = require("../../components/Box");
var date_fns_1 = require("date-fns");
var classnames_1 = __importDefault(require("classnames"));
var MDIcon_1 = require("../../components/MDIcon");
var react_1 = require("react");
var locale_1 = require("../../utils/locale");
var TimePicker = function (_a) {
  var height = _a.height,
    selected = _a.selected,
    _b = _a.disabled,
    disabled = _b === void 0 ? false : _b,
    _c = _a.disabledTime,
    disabledTime = _c === void 0 ? R.F : _c,
    _d = _a.interval,
    interval = _d === void 0 ? 30 : _d,
    onChange = _a.onChange,
    timeFormat = _a.timeFormat,
    locale = _a.locale,
    _e = _a.endOfDay,
    endOfDay = _e === void 0 ? false : _e;
  var timeData = (0, react_1.useMemo)(function () {
    var data = R.times(function (hours) {
      if (interval === 60) return [{
        hours: hours,
        minutes: 0,
        seconds: 0,
        milliseconds: 0
      }];
      if (interval === 15) return [0, 15, 30, 45].map(function (minutes) {
        return {
          hours: hours,
          minutes: minutes,
          seconds: 0,
          milliseconds: 0
        };
      });
      if (interval === 10) return [0, 10, 20, 30, 40, 50].map(function (minutes) {
        return {
          hours: hours,
          minutes: minutes,
          seconds: 0,
          milliseconds: 0
        };
      });
      return [0, 30].map(function (minutes) {
        return {
          hours: hours,
          minutes: minutes,
          seconds: 0,
          milliseconds: 0
        };
      });
    }, 24);
    var flat = R.flatten(data);
    return endOfDay ? R.append({
      hours: 23,
      minutes: 59,
      seconds: 59,
      milliseconds: 999
    }, flat) : flat;
  }, [interval]);
  return (0, jsx_runtime_1.jsxs)(Stack_1.Stack, __assign({
    className: (0, classnames_1.default)("vsx-time-picker", disabled && "disabled")
  }, {
    children: [(0, jsx_runtime_1.jsx)(Box_1.Box, __assign({
      className: "vsx-time-header",
      inline: true,
      justify: "center",
      align: "center"
    }, {
      children: (0, jsx_runtime_1.jsx)(MDIcon_1.MDIcon, {
        color: "var(--color-secondary-gray-2)",
        size: "1.2em",
        icon: "clock-outline"
      })
    })), (0, jsx_runtime_1.jsx)(ListView_1.ListView, {
      className: "vsx-time-list",
      style: {
        height: height
      },
      data: timeData,
      itemStyle: {
        borderBottom: "0 !important",
        padding: 0
      },
      renderContent: function (t) {
        return (0, jsx_runtime_1.jsx)(RenderTime, {
          time: t,
          locale: locale,
          timeFormat: timeFormat,
          selected: selected,
          disabled: disabledTime(t)
        });
      },
      onClick: function (item) {
        if (!disabled && !disabledTime(item)) {
          onChange(item);
        }
      }
    })]
  }));
};
exports.TimePicker = TimePicker;
var timeDisplay = function (time, locale, timeFormat) {
  if (timeFormat === void 0) {
    timeFormat = "p";
  }
  var date = new Date();
  var hours = time.hours,
    minutes = time.minutes,
    _a = time.seconds,
    seconds = _a === void 0 ? 0 : _a,
    _b = time.milliseconds,
    milliseconds = _b === void 0 ? 0 : _b;
  date.setHours(hours, minutes, seconds, milliseconds);
  return (0, date_fns_1.format)(date, timeFormat, {
    locale: (0, locale_1.getLocale)(locale)
  });
};
var RenderTime = function (_a) {
  var time = _a.time,
    selected = _a.selected,
    disabled = _a.disabled,
    _b = _a.locale,
    locale = _b === void 0 ? "en" : _b,
    timeFormat = _a.timeFormat;
  var isSelected = R.eqBy(R.pick(["hours", "minutes"]), time !== null && time !== void 0 ? time : {}, selected !== null && selected !== void 0 ? selected : {});
  var ref = (0, react_1.useRef)(null);
  var cn = (0, classnames_1.default)("vsx-render-time-item", isSelected && "selected", disabled && "disabled");
  var displayText = timeDisplay(time, locale, timeFormat);
  (0, react_1.useEffect)(function () {
    // Checking if ref.current.scrollIntoView exists is a workaround for jest
    //@ts-ignore 
    if (isSelected && ref.current && ref.current.scrollIntoView) {
      ref.current.scrollIntoView({
        block: "nearest",
        inline: "nearest"
      });
    }
  }, [isSelected, ref.current]);
  return (0, jsx_runtime_1.jsx)("div", __assign({
    ref: ref,
    className: cn
  }, {
    children: displayText
  }));
};